export const AUCTION_BIDDING_CHANNEL =
  'Establishment::Maintenance::EstablishmentChoice::AuctionEntries::BiddingChannel'
